import { render } from "./WorkCatalog.vue?vue&type=template&id=c84ea7b2&scoped=true"
import script from "./WorkCatalog.vue?vue&type=script&lang=js"
export * from "./WorkCatalog.vue?vue&type=script&lang=js"

import "./WorkCatalog.vue?vue&type=style&index=0&id=c84ea7b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84ea7b2"]])

export default __exports__